import { GeneratorStep, GeneratorV2FormState } from '../types/generatorV2';

export const generatorDraftKey = (userId: number, adminMode = false) => `whitepage:generator:draft:v1:${userId}${adminMode ? ':admin' : ''}`;
export const generatorActiveKey = (userId: number, adminMode = false) => `whitepage:generator:active:v1:${userId}${adminMode ? ':admin' : ''}`;
export const generatorRequestKey = (userId: number | null, adminMode = false) => `whitepage:generator:request:v1:${userId}${adminMode ? ':admin' : ''}`;

// Черновик содержит только настройки. Цены, права, прогресс и результаты всегда
// загружаются с сервера заново. Storage может быть недоступен в приватном режиме.
export function readGeneratorDraft(userId: number, defaults: GeneratorV2FormState, adminMode = false) {
  try {
    const raw = sessionStorage.getItem(generatorDraftKey(userId, adminMode));
    if (!raw || raw.length > 100000) return null;
    const saved = JSON.parse(raw);
    if (saved.version !== 1 || !saved.form || typeof saved.form !== 'object') return null;
    const form = { ...defaults };
    for (const key of Object.keys(defaults) as Array<keyof GeneratorV2FormState>) {
      const value = saved.form[key];
      const initial = defaults[key];
      if (typeof initial === 'string' && typeof value === 'string' && value.length <= 2000) {
        (form as any)[key] = value;
      } else if (typeof initial === 'boolean' && typeof value === 'boolean') {
        (form as any)[key] = value;
      } else if (initial === null && (value === null || (Number.isSafeInteger(value) && value > 0))) {
        (form as any)[key] = value;
      }
    }
    const enums: Partial<Record<keyof GeneratorV2FormState, string[]>> = {
      templateType: ['single', 'multi-page'], siteType: ['landing', 'multipage'],
      themeMode: ['template', 'list', 'custom'],
      communicationStyle: ['professional', 'friendly', 'aggressive', 'minimal', 'creative'],
      backgroundMode: ['disabled', 'static', 'dynamic', 'random'],
      backgroundPerformance: ['lightweight', 'balanced', 'visual_first'],
      componentVisualEffect: ['none', 'soft-gradient', 'glass-lite', 'mesh-light', 'glow-accent']
    };
    for (const [key, values] of Object.entries(enums)) {
      if (!values.includes((form as any)[key])) (form as any)[key] = (defaults as any)[key];
    }
    form.componentOpacity = typeof saved.form.componentOpacity === 'number' &&
      saved.form.componentOpacity >= 0 && saved.form.componentOpacity <= 1 ? saved.form.componentOpacity : null;
    for (const key of ['optionalComponentsState', 'componentVariantChoice'] as const) {
      const values = saved.form[key];
      form[key] = values && typeof values === 'object' && !Array.isArray(values)
        ? Object.fromEntries(Object.entries(values).filter(([id, value]) => /^[a-zA-Z0-9:_-]{1,100}$/.test(id) && !['__proto__', 'constructor', 'prototype'].includes(id) &&
          typeof value === 'string' && /^[a-zA-Z0-9_-]{1,100}$/.test(value) &&
          (key !== 'optionalComponentsState' || ['random', 'include', 'exclude'].includes(value)))) as any
        : {};
    }
    // Состав заново сверяется с актуальными правилами выбранного шаблона.
    form.selectedComponents = [];
    if (!form.htmlTemplate) return null;
    const step = Number.isInteger(saved.step) && saved.step >= 1 && saved.step <= 7 ? saved.step as GeneratorStep : 1;
    return { form, step, mode: saved.mode === 'quick' ? 'quick' as const : 'full' as const };
  } catch { return null; }
}
